import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=37cae95d&scoped=true"
import script from "./FaqView.vue?vue&type=script&lang=ts"
export * from "./FaqView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cae95d",
  null
  
)

export default component.exports